/**
 * @fileoverview
 * Functions for gathering client data and building core tracking payloads.
 */

import { pruneNilValues } from '@core/object'
import { StorageKeyPerformanceEnum } from '@core/storage/types'
import { getCookieWithFallback } from '@core/tracking/funnelTracking'
import { getOauthAppId } from '@core/tracking/oauthAppId'
import { getOS } from '@core/userAgent'
import { getPlatform } from '@embed/tools/utils'
import { getNextJsPublicEnv } from '@src/helpers'

import { nowAndNowLocalToString } from './nowAndNowLocal'
import { getTrackingProduct } from './tracking.utils'

const commonFields = (): Record<string, unknown> => ({
  platform: getPlatform(),
  product: getTrackingProduct(),
  product_version:
    getNextJsPublicEnv('RELEASE_VERSION') ?? process.env.RELEASE_VERSION,
  track_version:
    getNextJsPublicEnv('TRACK_VERSION') ?? process.env.TRACK_VERSION,
})

/**
 * Get root fields for pixel tracking
 */
export const getGlobalTrackingFields = (): Record<string, unknown> => {
  const { now } = nowAndNowLocalToString()

  return pruneNilValues({
    ...commonFields(),
    client_event_time: now,
    os_name: getOS(),
    host: document.location.host,
    oauth_app_uid: getOauthAppId(),
    _business_id: getCookieWithFallback(StorageKeyPerformanceEnum.fw_bid)
      ?.value,
  })
}
